// NOTE: Copied from workbench-icons based on guidance from design-systems
// because there was a problem with server side rendering and using these icons.
const MoneyBag = () => (
  <svg viewBox="0 0 16 16" width="1em" fill="currentColor">
    <path d="M8.75 4.5v.468c.292.15.546.374.734.655l.14.211a.75.75 0 11-1.248.832l-.14-.21a.461.461 0 00-.384-.206h-.07a.399.399 0 00-.151.767l1.128.462a1.959 1.959 0 01-.009 3.63v.391a.75.75 0 01-1.5 0v-.374a2.016 2.016 0 01-1.237-1.323l-.018-.064a.75.75 0 011.439-.423l.018.064c.065.22.266.37.495.37h.07a.459.459 0 00.174-.883l-1.128-.461a1.899 1.899 0 01.187-3.58V4.5a.75.75 0 011.5 0z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 8a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zM8 14A6 6 0 118 2a6 6 0 010 12z"
    />
  </svg>
);

export default MoneyBag;
